import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FooterDrawerService {
    isVisible$ = new BehaviorSubject(false);

    template$ = new Subject<TemplateRef<any>>();

    open(template: TemplateRef<any>) {
        this.isVisible$.next(true);
        this.template$.next(template);
    }

    close() {
        this.isVisible$.next(false);
    }
}
